import React from 'react';
import PublicationList from '../features/publications/PublicationList';

const Publications = () => {
    return (
        <div>
            <PublicationList />
        </div>
    );
};

export default Publications;